export default {
  state: {
    logout: {
      show: false,
      success: false
    }
  },
  mutations: {
    setLogoutData (state, data) {
      for (let field in data) {
        state.logout[field] = data[field]
      }
      if (data.show) state.logout.success = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global/logout.js